import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_2 = { class: "error-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DControlLabel = _resolveComponent("DControlLabel")!
  const _component_VeeError = _resolveComponent("VeeError")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-control-descriptor", { error: $props.errors[$props.name], success: $props.isSuccess }])
  }, [
    _createVNode(_component_DControlLabel, _mergeProps({
      class: ["d-control-input__label--static", {'d-control-input__label--disabled': $props.disabled}],
      "input-label": $props.staticLabel ? $props.staticLabel: $props.inputLabel,
      "is-required": _ctx.isRequired
    }, _ctx.$attrs, { value: $setup.inputValue }), null, 16, ["class", "input-label", "is-required", "value"]),
    (_openBlock(), _createBlock(_resolveDynamicComponent("VeeField"), _mergeProps(_ctx.$attrs, {
      name: $props.name,
      rules: $props.rules,
      id: _ctx.id,
      modelValue: _ctx.$attrs.modelValue,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.$attrs.modelValue) = $event))
    }), {
      default: _withCtx(({ field, handleInput }) => [
        _hoisted_1,
        (_openBlock(), _createBlock(_resolveDynamicComponent($setup.inputComponent), _mergeProps({ class: "d-control-descriptor__element" }, { ...$setup.getFP(field), ..._ctx.$attrs, ...$setup.props}, {
          labelBy: $props.labelBy,
          "set-value": $props.setValue,
          slots: _ctx.$slots,
          modelValue: _ctx.$attrs.modelValue,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$attrs.modelValue) = $event)),
            $setup.updateModelValue
          ],
          placeholder: $props.staticLabel,
          onUpdateModel: $setup.updateValue,
          "onUpdate:isValid": _cache[1] || (_cache[1] = ($event: any) => ($setup.isValid = $event)),
          onClearMultiselect: _cache[2] || (_cache[2] = ($event: any) => ($setup.emit('clearMultiselect')))
        }), _createSlots({ _: 2 }, [
          _renderList($setup.eSlots, (name, key) => {
            return {
              name: name,
              fn: _withCtx((binded) => [
                _renderSlot(_ctx.$slots, key, _normalizeProps(_guardReactiveProps(binded)))
              ])
            }
          })
        ]), 1040, ["labelBy", "set-value", "slots", "modelValue", "placeholder"]))
      ]),
      _: 3
    }, 16, ["name", "rules", "id", "modelValue"])),
    _createVNode(_component_VeeError, { name: $props.name }, {
      default: _withCtx(({ message }) => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(message), 1)
      ]),
      _: 1
    }, 8, ["name"])
  ], 2))
}